/**************************************************************************************************/
/*   File: /src/app/shared/directives/row-expander/row-e                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday May 10th 2019                                                           */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/

import {
    Directive,
    ElementRef,
    AfterContentInit,
    ComponentFactoryResolver,
    ApplicationRef,
    Renderer2,
    ComponentRef,
    ReflectiveInjector,
    EmbeddedViewRef,
    OnDestroy,
    Output,
    EventEmitter,
    Input,
    SimpleChanges,
    OnChanges
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ExpanderComponent } from '../../components/expander/expander.component';
import { Subscription } from 'rxjs';

/**
 * The directive for Row expander
 */
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[row-expander]'
})
export class RowExpanderDirective implements AfterContentInit, OnDestroy, OnChanges {
    /**
     * Is expanded ionput
     * @type {boolean}
     */
    @Input() isExpanded: boolean;
    /**
     * The top element position of the row expander
     * @type {number}
     */
    private elementPositionTop: number;
    /**
     * The left element position of the row expander
     * @type {number}
     */
    private elementPositionLeft: number;
    /**
     * The component added
     * @type {componentRef}
     */
    private componentRef: ComponentRef<ExpanderComponent>;
    /**
     * The id of generated component
     * @type {string}
     */
    private _id = Math.floor(Math.random() * Math.pow(10, 6)).toString();
    /**
     * The expanded emitter
     * @type {EventEmitter<boolean>}
     */
    @Output() expanded: EventEmitter<boolean> = new EventEmitter<boolean>();
    /**
     * The array of subscription
     */
    private subscriptions: Subscription[] = [];
    /**
     * The constructor
     */
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private el: ElementRef,
        private appRef: ApplicationRef,
        private renderer: Renderer2,
        private logger: NGXLogger) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ExpanderComponent);
        // tslint:disable-next-line
        const injector = ReflectiveInjector.resolveAndCreate([]);
        this.componentRef = componentFactory.create(injector);

    }

    /**
     * The ng after content init life cycle hook
     */
    ngAfterContentInit(): void {
        const viewportOffset = this.el.nativeElement.getBoundingClientRect();
        // these are relative to the viewport, i.e. the window
        this.elementPositionLeft = viewportOffset.top;
        this.elementPositionLeft = viewportOffset.left;
        this.componentRef.instance.isExpanded = this.isExpanded;

        this.logger.trace('The position of the row expander is', this.elementPositionTop, this.elementPositionLeft);


        setTimeout(
             /* istanbul ignore next */
            () => {
                 /* istanbul ignore next */
                const view = this.componentRef.hostView;
                this.appRef.attachView(view);
                 /* istanbul ignore next */
                const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
                    .rootNodes[0] as HTMLElement;
                domElem.id = this._id;

                domElem.style.position = 'relative';
                /* this.el.nativeElement.children[0].style.marginLeft = `${this.width * 100}%`;
                 domElem.style.width = `${this.width * 100}%`;*/

                  /* istanbul ignore next */
                this.renderer.insertBefore(this.el.nativeElement, domElem, this.el.nativeElement.children[0]);
                 /* istanbul ignore next */
                const subscription = this.componentRef.instance.expanded.subscribe(
                    (value) => {
                        this.expanded.emit(value);
                    }
                );
                this.subscriptions.push(subscription);

            }, 0);
    }
    /**
     * On destroy hook
     */
    ngOnDestroy() {
        const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;
        this.renderer.removeChild(this.el.nativeElement, domElem);
        /* this.logger.trace('Remove subscriptions RowExpanderComponent'); */
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * The ng on changes life cycle hook
     * @param changes The simple changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.isExpanded) {
            this.componentRef.instance.isExpanded = changes.isExpanded.currentValue;
        }
    }

}
